import * as React from 'react';
import {getTypeName} from 'features/services/utils/name-helpers';
import {Tag} from "features/search/types";

export const markFirstWordInSentence = (searchString: string, sentence: string, type: string): React.ReactNode | null => {
    const input = searchString.toLowerCase();
    const original = `${sentence} ${getTypeName(type)}`;
    const lower = original.toLowerCase();
    const startIndex = lower.indexOf(input);

    if (startIndex === -1) {
        return original;
    }

    const before = original.substring(0, startIndex);
    const match = original.substring(startIndex, startIndex + input.length);
    const after = original.substring(startIndex + input.length);

    return <>{before}<span className="tag-menu-item__marked-word">{match}</span>{after}</>;
};

export const getSortedTagsAmount = (sortedTags: { [key: string]: Tag[] }) => {
    let amount = 0;

    Object.keys(sortedTags).map((key) => {
        amount += sortedTags[key].length;
    });

    return amount;
};

export const getFlattenedTags = (sortedTags: { [key: string]: Tag[] }) => {
    const tags: Tag[] = [];

    Object.keys(sortedTags).map((key) => {
        tags.push(...sortedTags[key])
    });

    return tags;
};

export const sortTagsByCategory = (tags: Tag[], input?: string) => {

    const sorted: {
        [key: string]: Tag[],
        geography: Tag[],
        stage: Tag[],
        streets: [],
        keywords: Tag[],
    } = {
        geography: [],
        stage: [],
        streets: [],
        keywords: [],
    };

    tags.map((tag) => {

        let categoryType = '';

        if(!tag.type || tag.active === false) return;

        switch (tag.type) {
            case 'area':
            case 'municipality':
            case 'county':
                categoryType = 'geography';
                break;
            case 'stage':
                categoryType = 'stage';
                break;
            case 'street':
                categoryType = 'streets';
                break;
            default:
                categoryType = 'keywords';

        }

        sorted[categoryType].push(tag);
    });

    let x = 0;
    const sortedSorted: { [key: string]: Tag[] } = {};



    Object.keys(sorted).sort().forEach(function(key: string) {
        sortedSorted[key] = sorted[key];
    });

    Object.keys(sortedSorted).map((key: string, _index: number) => {
        sortedSorted[key].sort((a: Tag, b: Tag) => {
            const numberA = a.rank;
            const numberB = b.rank;
            if(numberA !== undefined && numberB !== undefined)
                return (numberA < numberB) ? 1 : (numberA > numberB) ? -1 : 0;
            else
                return 0;
        }).map((tag: Tag) => {

            tag.index = x;
            x++;
        });
    });

    // Sort tags that starts with inputvalue first

    if(input && input.length > 0) {
        let y = 0;
        Object.keys(sortedSorted).map((key: string) => {

            const startsWithArray: Tag[] = [];
            const inWithArray: Tag[] = [];

            sortedSorted[key].map((tag: Tag) => {

                if(tag.name.toLowerCase().startsWith(input.toLowerCase())) {
                    startsWithArray.push(tag);
                } else {
                    inWithArray.push(tag);
                }

                startsWithArray.sort();
                inWithArray.sort();
            });

            sortedSorted[key] = startsWithArray.concat(inWithArray).map((tag: Tag) => {

                tag.index = y;
                y++;

                return tag;
            });

        });
    }


    return sortedSorted;
};
